import {
  Component,
  OnInit,
  Input,
  forwardRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  EventEmitter,
  Output,
} from '@angular/core'
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from '@angular/forms'
import {StorageService} from '../../core/upload/upload.service'

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  cansubmit: boolean = true
  files: Array<File> = []
  map = {
    database: [],
    iterate: [],
    files: [],
  }
  keepstructure: boolean = false
  @Input() uploadpath: string
  @Input() user: any
  @Output() filesUploaded = new EventEmitter<any>()

  constructor(public storage: StorageService) {}

  ngOnInit() {
    // console.log(this.uploadpath)
  }

  addFiles(e) {
    if (e && e.target && e.target.files && e.target.files.length >= 0) {
      // console.log(e.target.files)
      for (let i = e.target.files.length - 1; i >= 0; i--) {
        this.files.push(e.target.files[i])
      }
      e.target.value = ''
      this.mapFiles()
    }
  }

  mapFiles() {
    this.map = this.storage.mapFiles(this.files, this.uploadpath, this.user)
  }

  clear() {
    this.files = []
    this.mapFiles()
  }

  startUpload(e) {
    this.cansubmit = false
    this.storage.uploadFiles(this.map.files).then(() => {
      this.filesUploaded.emit(this.map.database)
    })
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/file-upload/file-upload.component.ts